import React from 'react';
import { Parasol2 } from 'react-parasol';
import { css } from '@emotion/core';
import Teaser from "./Teaser";
import RowTitle from './RowTitle';

const teaserRow = css`
  &:first-of-type {
    & > .headline {
      margin-top: 0;
    }
  }
`;

export default class TeaserRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: null,
      favorites: {},
      selector: Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 10)
    };

    this.addFavorite = this.addFavorite.bind(this);
    this.removeFavorite = this.removeFavorite.bind(this);

    this.hover = this.hover.bind(this);
    this.resetHover = this.resetHover.bind(this);
  }

  addFavorite(id) {
    this.setState((prevState) => {
      let { favorites } = prevState;
      favorites[id] = true;
      return { favorites };
    });
  }

  removeFavorite(id) {
    this.setState((prevState) => {
      let { favorites } = prevState;
      favorites[id] = false;
      return { favorites };
    });
  }

  hover(pos) {
    this.setState(() => {
      return {
        hovered: pos
      };
    });
  }

  resetHover() {
    this.setState(() => {
      return {
        hovered: null
      };
    });
  }

  renderLoading() {
    let { breakpoints, ItemPlaceholder } = this.props;

    return <Parasol2 breakpoints={breakpoints}>
      {
        [0, 1, 2, 3, 4, 5].map(i => {
          return <ItemPlaceholder key={i} />;
        })
      }
    </Parasol2>;
  }

  renderItems() {
    let { title, Item, breakpoints, appName } = this.props;
    let { hovered } = this.state;

    return <Parasol2 breakpoints={breakpoints} onScroll={this.resetHover} onMouseLeave={this.resetHover}>
      {
        this.props.items.map((w, i) => {
          return <Teaser
            key={`${i}-${w.id}`}
            hoverPos={hovered}
            viewPosition={null}
            page={1}
            pageSize={0}
            onMouseEnter={this.hover}
          >
            <Item
              {...w}
              trackingLabelPrefix={title}
              addFavorite={this.addFavorite}
              removeFavorite={this.removeFavorite}
              favorite={!!this.state.favorites[w.id]}
              {...this.props.itemProps}
            />
          </Teaser>;
        })
      }
    </Parasol2>;
  }

  render() {
    let { title, failedToLoad } = this.props;

    if (failedToLoad) {
      return null;
    }

    return <div css={teaserRow} className={`teaser-row ${this.state.selector}`}>
      <RowTitle title={title} />
      {this.props.items && this.props.items.length > 0 && this.renderItems() || this.renderLoading()}
    </div>;
  }
}